export const getAuthToken = () => localStorage.getItem("token");

export const getAuthHeaders = (extraHeaders = {}) => {
  const token = getAuthToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
        ...extraHeaders,
      }
    : { ...extraHeaders };
};
